import { createProvider } from '@frontend/store';
import { TemplatePreviewStore, TemplatePreviewStoreState } from './type';

const INITIAL_STATE: TemplatePreviewStoreState = {
  previewMode: 'desktop',
};

export const { Provider: TemplatePreviewStoreProvider, useStore: useTemplatePreviewStore } =
  createProvider<TemplatePreviewStore>()((set) => ({
    ...INITIAL_STATE,
    setPreviewMode: (previewMode) => set({ previewMode }),
  }));
